import { createContext, ReactNode, useContext } from 'react';

import { State } from '../../../types/video';

type Props = {
  state?: State;
  setClient: () => void;
  setLoading: (loading: boolean) => void;
  setStep: (step: number) => void;
  setCall: () => void;
  setCallState: (callState: object) => void;
  setCustomControls: (bool: boolean) => void;
  setJoined: (bool: boolean) => void;
};

type ProviderProps = {
  children: ReactNode | undefined;
  state: State;
  value: {
    setClient: () => void;
    setLoading: (loading: boolean) => void;
    setStep: (step: number) => void;
    setCall: () => void;
    setCallState: (callState: object) => void;
    setCustomControls: (bool: boolean) => void;
    setJoined: (bool: boolean) => void;
  };
};

const VideoContext = createContext<Props>({
  state: undefined,
  setClient: () => null,
  setLoading: () => null,
  setStep: () => null,
  setCall: () => null,
  setCallState: () => null,
  setCustomControls: () => null,
  setJoined: () => null,
});

export const VideoContextProvider = ({
  children,
  state,
  value,
}: ProviderProps) => {
  return (
    <VideoContext.Provider
      value={{
        state,
        ...value,
      }}
    >
      {children}
    </VideoContext.Provider>
  );
};

export const useVideoContext = () => useContext(VideoContext);
